/**
 * 📱 O RECORTE DO APARELHO, PARA A CASCA DO PAINEL (barra de cima e gaveta do menu).
 *
 * ─── O QUE ELE VIU (print dele, 16/09/2026 22h59) ───────────────────────────
 * Dois prints do MESMO painel, no mesmo minuto. No Safari a barra do app estava lá:
 * hamburger · "M5 Group · Painel" · sino (9+) · seletor de empresa. **No app instalado ela
 * sumiu** — desenhada debaixo do relógio e da bateria, dava pra ver só o fantasma dela atrás
 * da barra de status. Sem hamburger, sem sino, sem troca de empresa.
 *
 * ─── A CAUSA, QUE JÁ TINHA NOME ─────────────────────────────────────────────
 * É a MESMA de `janelaDaDuda` (#2573, três horas antes): o `index.html` pede
 * `viewport-fit=cover`, então no app instalado a página desenha DEBAIXO da barra de status.
 * Aquele PR deu a folga à janela da Duda — e só a ela. A casca do app ficou de fora: em todo
 * o `main`, `safe-area-inset` aparecia em três linhas, as três dentro de `janelaDaDuda.ts`.
 * A barra do app (`sticky top-0`) e a gaveta do menu (`fixed top-0 bottom-0`) continuavam
 * encostando no topo da tela física.
 *
 * No navegador nada disso aparece, porque a barra do Safari empurra a página pra baixo — foi
 * exatamente o que escondeu o defeito da Duda até ele abrir o app instalado.
 *
 * ─── AS DUAS DECISÕES ───────────────────────────────────────────────────────
 *
 * 1. 🔑 A FOLGA É DO APARELHO, `env(safe-area-inset-*)` — nunca um número. Altura de barra
 *    muda por modelo e por orientação: cravar 44 conserta um telefone, quebra o próximo e
 *    deixa faixa vazia em quem não tem recorte. Em aparelho sem recorte o `env` vale 0 e
 *    tudo isto some sozinho, então não há "só no PWA" pra detectar — o navegador já
 *    responde 0 e a barra fica como sempre foi.
 *
 * 2. 🚪 A GAVETA LEVA FOLGA DOS DOIS LADOS. Em cima mora o X de fechar; embaixo, "Sair" e os
 *    botões de senha e tema. É o mesmo defeito da janela da Duda na sua forma mais séria:
 *    abrir uma coisa que cobre a tela inteira e esconder a saída dela.
 *
 * Puro de propósito, como `janelaDaDuda`: decisão de layout se prova sem pintar tela.
 */
import type { CSSProperties } from "react";

/** O `py-3` da barra, em rem. Vive aqui porque o `calc` abaixo PRECISA repetir esse número. */
export const RESPIRO_DA_BARRA = "0.75rem";

/**
 * A barra de cima do painel (hamburger · nome · sino · seletor de empresa).
 *
 * Só a folga de CIMA: a barra é `sticky top-0` e não encosta no rodapé. Ela pinta `bg-card`,
 * então a faixa da folga sai na cor da barra e o conteúdo rola por baixo dela, sólida.
 *
 * 🟥 E A FOLGA SOMA, NÃO SUBSTITUI (pego na conferência ao vivo, 16/09/2026). A primeira
 * versão devolvia `env(safe-area-inset-top)` seco, igual à janela da Duda. Só que a janela da
 * Duda não tem respiro próprio e esta barra tem: `py-3`. `style` inline ganha da classe, então
 * onde NÃO há recorte — o navegador de computador, o Safari do celular, todo telefone sem
 * notch — o `env` valia 0, zerava o `py-3` junto e a barra encolhia de 61px para 49px. Medido
 * no Chrome dele, na produção: `padding-top` 12px → 0px. Eu teria consertado o app instalado
 * quebrando todo o resto — e nenhum teste de jsdom veria, porque lá `env(...)` nem resolve.
 */
export function folgaDaBarraDoApp(): CSSProperties {
  return { paddingTop: `calc(${RESPIRO_DA_BARRA} + env(safe-area-inset-top))` };
}

/**
 * A gaveta do menu no celular (`fixed left-0 top-0 bottom-0`).
 *
 * Os dois lados: em cima o X de fechar, embaixo o "Sair". A de baixo é a barra de gestos.
 */
export function folgaDaGavetaDoCelular(): CSSProperties {
  return {
    paddingTop: "env(safe-area-inset-top)",
    paddingBottom: "env(safe-area-inset-bottom)",
  };
}
